import { toast } from "react-toastify";
import defaultErrorHandler from "actions/global/default-error-handler";

import {
  requestNoPagination,
  requestCreateTemplate,
  requestUpdateTemplate,
  requestDeleteTemplate,
} from "actions/notificationTemplates/requests";

import {
  NOTIFICATION_TEMPLATES_ERROR,
  NOTIFICATION_TEMPLATES_LOADING,

  NOTIFICATION_TEMPLATES_CREATE,
  NOTIFICATION_TEMPLATES_GET_LIST,
  NOTIFICATION_TEMPLATES_DELETE
} from "actions/notificationTemplates/constants";

export const setLoading = status => ({
  type: NOTIFICATION_TEMPLATES_LOADING,
  payload: status
});

export const getNoPagination = (filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestNoPagination(filters)
    .then(response => {
      dispatch({
        type: NOTIFICATION_TEMPLATES_GET_LIST,
        payload: response.data
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, NOTIFICATION_TEMPLATES_ERROR));
    });
};

export const createTemplate = (data, callback) => dispatch => {
  requestCreateTemplate(data)
    .then(response => {
      dispatch({
        type: NOTIFICATION_TEMPLATES_CREATE,
        payload: {
          create: true,
          data: response.data.content
        }
      });
      toast("Template created successfully", {
        type: toast.TYPE.SUCCESS,
      });
      callback(true);
    })
    .catch(error => {
      dispatch(setLoading(false));
      dispatch(defaultErrorHandler(error, NOTIFICATION_TEMPLATES_ERROR));
    });
};

export const updateTemplate = (id, data, callback) => dispatch => {
  requestUpdateTemplate(id, data)
    .then(response => {
      dispatch({
        type: NOTIFICATION_TEMPLATES_CREATE,
        payload: {
          create: false,
          data: response.data.content
        }
      });
      toast("Template updated successfully", {
        type: toast.TYPE.SUCCESS,
      });
      callback(true);
    })
    .catch(error => {
      dispatch(setLoading(false));
      dispatch(defaultErrorHandler(error, NOTIFICATION_TEMPLATES_ERROR));
    });
};

export const deleteTemplate = (id) => dispatch => {
  requestDeleteTemplate(id)
    .then(() => {
      dispatch({
        type: NOTIFICATION_TEMPLATES_DELETE,
        payload: id
      });
      toast("Template removed successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch(error => {
      dispatch(setLoading(false));
      dispatch(defaultErrorHandler(error, NOTIFICATION_TEMPLATES_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/notificationTemplates/actions.js